import { faSparkles } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { TextareaAutosize } from "@mui/base";
import { Controller, useFormContext } from "react-hook-form";

import Chip from "../../../../common/chips/Chip";
import { PREFERENCES_PREFILLS } from "../../../constants";

export default function PreferencesSection({ control }) {
  const { getValues, setValue } = useFormContext(control);
  const currentValue = getValues("userPreferences");

  const handleChipClick = (prefill) => {
    const newValue = currentValue
      ? `${currentValue} ${prefill.description}`
      : prefill.description;

    setValue("userPreferences", newValue);
  };

  return (
    <>
      <label
        htmlFor="userPreferences"
        className="block text-sm font-semibold text-gray-700 dark:text-gray-200 mb-1"
      >
        Preferences
      </label>
      <div className="flex flex-wrap items-center gap-2 mb-2">
        <FontAwesomeIcon
          icon={faSparkles}
          size="lg"
          className="text-yellow-400"
        />{" "}
        {Object.entries(PREFERENCES_PREFILLS).map(([key, value]) => (
          <Chip
            key={key}
            label={key}
            onClick={() => handleChipClick(value)}
            dataTestId={`preference-${key}`}
          />
        ))}
      </div>
      <Controller
        control={control}
        name="userPreferences"
        render={({ field: { onChange, value, ref } }) => (
          <TextareaAutosize
            id="userPreferences"
            name="userPreferences"
            data-testid="user-preferences"
            minRows={3}
            placeholder="Describe your stylistic preferences or instructions. Eg. 'If there is no abnormal finding for a particular system, do not include it in the note.'"
            // hack to dodge js errors because react-hook-form sometimes passes an empty object as the value
            value={
              ["string", "number"].includes(typeof value) ? value : ""
            }
            onChange={(e) => {
              onChange(e);
            }}
            ref={ref}
            className="resize-none appearance-none relative block w-full p-3 border-2 dark:bg-gray-700 dark:border-gray-700 dark:text-gray-200 border-gray-100 bg-gray-100 placeholder-gray-400 text-gray-900 rounded-xl focus:border-indigo-300 dark:focus:border-indigo-300 z-10 text-xs md:text-sm h-8"
          />
        )}
      />
    </>
  );
}
